import { Access } from "@p0security/shared/types/access/index";

import {
  policyIdParameter,
  policyNameParameter,
  sudoParameter,
} from "./parameters.ts";

export const commonAllAccess = Access({
  description: "All resources",
  label: "All grantable instances",
  maturity: "ga",
  delegation: {},
  generated: {},
  parameters: {
    sudo: sudoParameter,
    policyId: policyIdParameter,
    policyName: policyNameParameter,
  },
  render: { locator: "policyName", policy: "sudo" } as const,
});
